import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import { Toggle } from 'components/Form/Toggle';
import { SuggestionsSelector } from 'components/Form/SuggestionsSelector';
import { WithAddon } from 'components/Form/WithAddon';
import { ErrorMessage, Message } from 'components/Message';


interface Props
{
  featureId: number,
}

export const FeatureBoundedToggleCreator: React.FC<Props> = observer(({featureId}) =>
{
  const { uiStore, toggleStore } = useStore();

  const [isToggleOn, setIsToggleOn] = useState(true);

  const [errorMessage, setErrorMessage] = useState('');
  const [scopeInput, setScopeInput] = useState('');
  const [scopeSuggestions, setScopeSuggestions] = useState<string[]>([]);
  const [scopeSuggestionsLoading, setScopeSuggestionsLoading] = useState(false);
  const [scopeSuggestionsVisible, setScopeSuggestionsVisible] = useState(false);

  const scopeInputChangeHandler = async (newValue: string) =>
  {
    setScopeInput(prev => newValue);
    setScopeSuggestionsLoading(prev => true);
    const suggestions = await toggleStore.requestScopeSuggestionsAsync(newValue);
    setScopeSuggestionsLoading(prev => false);
    setScopeSuggestions(prev => suggestions);
  }

  const createToggleHandler = async () =>
  {
    setErrorMessage(prev => '');
    await toggleStore.createAsync(featureId, scopeInput, isToggleOn);
    if (toggleStore.toggle.isError)
    {
      setErrorMessage(prev => toggleStore.toggle.errorMessage);
    }
  }

  return (
    <div>
      <div className="toggle-creator">
        <Toggle value={isToggleOn} onClick={() => setIsToggleOn(prev => !prev)} />
        <SuggestionsSelector isLoading={scopeSuggestionsLoading}
                            suggestionsVisible={scopeSuggestionsVisible}
                            noSuggestionsView={<Message>{uiStore.labels.common.forms.createToggle.scope.suggestionsInstruction}</Message>}
                            suggestions={scopeSuggestions}
                            maxSuggestions={10}
                            suggestionKeySelector={x => x}
                            suggestionViewTemplate={x => x}
                            onSuggestionSelect={async x => await scopeInputChangeHandler(x)} >
          <WithAddon leftAddon={<>/</>}>
            <input type="text"
                  placeholder={uiStore.labels.common.forms.createToggle.scope.placeholder}
                  value={scopeInput}
                  onChange={async e => await scopeInputChangeHandler(e.target.value)}
                  onFocus={() => setScopeSuggestionsVisible(prev => true)}
                  onBlur={() => setScopeSuggestionsVisible(prev => false)} />
          </WithAddon>
        </SuggestionsSelector>
        <button onClick={createToggleHandler} disabled={toggleStore.toggle.isLoading}>{uiStore.labels.common.forms.add}</button>
      </div>
      { errorMessage.length > 0 ? <ErrorMessage>{errorMessage}</ErrorMessage> : null }
    </div>
  );
});